var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-chart',_vm._b({directives:[{name:"resize",rawName:"v-resize:debounce.80",value:(_vm.rerenderOnResize),expression:"rerenderOnResize",arg:"debounce",modifiers:{"80":true}}],ref:"chart"},'dx-chart',_vm.computedChartConfig,false))}
var staticRenderFns = []

export { render, staticRenderFns }